import styled, { css } from 'styled-components'
import { tokens } from 'styling/tokens'

const SEVERITY_COLOR: { [k in 'critical' | 'warning']: string } = {
  critical: tokens.status.danger.fg,
  warning: tokens.status.warning.fg,
}

export const ReviewStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`

export const SubtitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.25rem;
`

export const ExceptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const ExceptionRow = styled.div<{ $clickable?: boolean }>`
  display: grid;
  grid-template-columns: 3.5rem 1rem minmax(0, 1fr) auto;
  column-gap: 0.75rem;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  transition: background ${tokens.motion.duration} ${tokens.motion.ease},
    border-color ${tokens.motion.duration} ${tokens.motion.ease};
  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;
      &:hover {
        background: ${tokens.surface.glass};
        border-color: ${tokens.border.strong};
      }
    `}
`

export const ExceptionTime = styled.span`
  font-family: ui-monospace, 'SF Mono', Menlo, monospace;
  font-size: ${tokens.font.label};
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  color: ${tokens.text.muted};
`

export const ExceptionDot = styled.span<{ $tone: 'critical' | 'warning' }>`
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 999px;
  justify-self: center;
  background: ${({ $tone }) => SEVERITY_COLOR[$tone]};
  box-shadow: 0 0 0.5rem ${({ $tone }) => SEVERITY_COLOR[$tone]};
`

export const OpenLink = styled.span`
  font-size: ${tokens.font.label};
  font-weight: 600;
  white-space: nowrap;
  color: ${tokens.text.muted};
  transition: color ${tokens.motion.duration} ${tokens.motion.ease};

  ${ExceptionRow}:hover & {
    color: ${tokens.accent.base};
  }
`

export const PeopleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const PeopleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const PeopleBullet = styled.span<{ $accent?: boolean }>`
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 999px;
  flex-shrink: 0;
  background: ${({ $accent }) => ($accent ? tokens.status.success.fg : tokens.text.muted)};
`

export const LockNoteWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.75rem 0 0.25rem;
  border-top: 1px solid ${tokens.border.hairline};
`

export const InfoNote = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  background: ${tokens.status.info.bg};
`

export const ReviewCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const ReviewId = styled.span<{ $active?: boolean }>`
  font-family: ui-monospace, 'SF Mono', Menlo, monospace;
  font-size: ${tokens.font.label};
  font-variant-numeric: tabular-nums;
  color: ${({ $active }) => ($active ? tokens.accent.base : tokens.text.muted)};
`
